// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
/* eslint-disable no-unused-vars */
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  credential: {
    Title: 1,
    ForeName: null,
    SurName: null,
    EmailID: null,
    Password: null,
    ConfirmPassword: null,
    Mobile: null,
    BookshopName: null,
    NewsLetter: false,
    DateofBirth: '12-12-2012',
    address: {
      AddressLine1: null,
      AddressLine2: null,
      County: null,
      Town: null,
      Postcode: null,
      Country: 1,
    },
  },
  errors: {
    common: null,
    ForeName: null,
    SurName: null,
    EmailID: null,
    Password: null,
    ConfirmPassword: null,
    Mobile: null,
    address: {
      AddressLine1: null,
      AddressLine2: null,
      Town: null,
      Postcode: null,
      County: null,
    },
  },
};

const registerReducer = createReducer(initialState, {
  [types.REGISTER_REQUEST](state, action) {
    return {
      ...state,
      action
    };
  },
  [types.REGISTER_FAILED](state, action) {
    return {
      ...state,
      errors: {
        ...state.errors,
        common: action.error.Reason,
      },
    };
  },
  // ---
  [types.REGISTER_ADDRESS_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      credential: {
        ...state.credential,
        address: Object.assign({}, state.credential.address, { [payload.field]: payload.value }),
      },
    };
  },
  [types.REGISTER_BANK_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      credential: {
        ...state.credential,
        bank: Object.assign({}, state.credential.bank, { [payload.field]: payload.value }),
      },
    };
  },
  [types.REGISTER_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      credential: Object.assign({}, state.credential, { [payload.field]: payload.value }),
    };
  },
  [types.REGISTER_ERRORS_CHANGE](state, payload) {
    return {
      ...state,
      errors: Object.assign({}, state.errors, { [payload.field]: payload.error }),
    };
  },
  // ---
  [types.REGISTER_FORM_RESET](state, action) {
    return initialState;
  },
  [types.REGISTER_SELECTED_ADDRESS_REQUEST](state, action) {
    return {
      ...state,
    };
  },
  [types.PHONE_NUMBER_VALIDATION_FAILED](state, action) {
    return {
      ...state,
      errors: {
        ...state.errors,
        ...action.error,
      },
    };
  },
});

export default registerReducer;
